export default __webpack_public_path__ + "static/media/quote.f23463e9.svg";